<template>
  <footer data-color="clear" class="c-footer u-bg--brand-dark u-align-center js-header-panel">
    <section v-if="newsletterShown" data-color="clear" class="u-relative u-fit-w u-bg--gray-lighter__2 u-overflow-h js-header-panel">
            <img src="../../assets/medias/images/PatternFooterMailingList1.jpg" class="o-wrapper--panel u-fit u-object-fit-cover">
            <img src="../../assets/medias/images/Contact us X bar.png" class="o-wrapper--panel u-fit u-object-fit-cover">
        <div class="u-relative u-fit-w">
      <div class="u-flex u-flex-fd--column@sm  u-align-left u-pad-t-xl u-pad-x-w2of12">
        <app-scroll-object   :offset=".05"   :isParallax="!1" inline-template  :content="content" >
               <div class="w2of10 u-w1of3@md u-fit-w@sm">
                 <h3 class="t-h3 t-text--roman u-relative u-marg-r-lg u-marg-r-0@sm u-color--gray" >
                       <span class="c-number-offset t-text--xl--Light u-absolute u-pos-bl3x" >02</span>
                       <app-words  :isActive="isActive" :delay="0" :content="content.newsletter_title"></app-words>
                   </h3>
               </div>
         </app-scroll-object>
         <div class="c-contact__section__location__details  u-flex u-w5of8">
            <div class="u-marg-b-md u-flex u-fit-w t-text--xl t-text-lh--lg u-color--black ">
               <div class="u-w2of2"  ></div>
            </div>
          </div>
        </div>
   </div>
   <div  class="u-relative u-pad-y-ultra u-pad-y-xxl@sm">
     <core-ajax-form inline-template :action="'/api/rgh/'" :content="content">
                <form :enctype="enctype" :method="method"  :action="action" class="js-form">
                  <core-ajax :src="action" :method="method" :contentType="enctype" :data="formData" :header="headers" :auto="!1" @on:success="onFormSuccess" @on:error="onFormError" inline-template>
                    <div></div>
                  </core-ajax >
                     <div class="u-relative u-vacuum">

                       <core-input  :isRequired="!0" :type="email" :content="content" @on:success="onInputSuccess(0)" @on:error="onInputError(0)"  @on:mounted="onInputMounted" inline-template>
                         <div class="c-footer__input u-relative u-inline-block u-valign-top u-marg-r-sm u-w2of8 u-w4of8@sm u-w6of8@xs u-marg-r-0@xs u-marg-b-xl@sm" style="border: 1px solid rgb(0, 0, 0);">
                             <input type="mail" autocomplete="off" name="mail" :placeholder="content.newsletter_placeholder" class="t-input t-text--sm u-relative u-pad-l-md u-fit-w u-fit-h u--color-input"  @blur="onFocusOut"   />
                             <span class="c-footer__input__msg c-footer__input__msg--error-format u-absolute t-text--xs u-color--black" v-html="content.newsletter_error_not_valid"></span>
                             <span class="c-footer__input__msg c-footer__input__msg--success u-absolute t-text--xs u-color--black" v-html="content.newsletter_success_saved"></span>
                             <span class="c-footer__input__msg c-footer__input__msg--error u-absolute t-text--xs u-color--black" v-html="content.newsletter_error_wrong"></span>
                           </div>
                         </core-input>
                             <button class="c-footer__btn-submit t-btn t-btn--primary t-text--sm u-relative u-bg--brand-Botton-color u-color--white u-pad-x-md" @click="onFormSubmit" v-html="content.newsletter_button_label">
                                <div class="t-btn--primary__bg o-wrapper--panel u-fit"></div>
                                <span class="u-relative u-inline-block u-valign-middle u-marg-r-sm" v-html="content.newsletter_button_label"></span>
                                <img src="../../assets/medias/images/icons/arrow-right-white.svg" class="t-icon--arrow-right u-relative u-inline-block u-valign-middle"/>
                             </button>
                         </div>
                         </form>
          </core-ajax-form>
       </div>
</section>
<section v-if="careersShown"  data-color="dark" class="u-relative u-overflow-h u-fit-w js-header-panel u-bg--white"  id="careersection" >

  <img src="../../assets/medias/images/footer-pattern.jpg" class="o-wrapper--panel u-fit u-object-fit-cover">
  <div class="u-relative u-fit-w">
      <div class="u-flex u-flex-fd--column@sm u-align-left  u-pad-x-w2of12">
            <div class="c-page c-blog  u-pad-x-w1of12@sm  u-fit-w">
              <header >
               <h3 class="t-h3 t-text--roman u-relative u-marg-t-xxl u-marg-r-lg u-marg-r-0@sm u-color--gray" >
                    <span class="c-number-offset t-text--xl--Light u-absolute u-pos-bl3x" >02</span>
                    <app-sliced-text :content="'Submit Your CV'"></app-sliced-text>
                </h3>
                <div class="u-flex u-flex-fd--row  u-flex__item-as--start u-fit-w  u-marg-b-lgs u-hide@md">
                </div>
            </header>
            </div>
      </div>
  </div>
  <div  class="u-relative u-pad-y-ultra u-pad-y-xxl@sm">

                 <core-ajax-form   :enctype="'multipart/form-data'"  :processIn="!1" inline-template :action="'/api/rgh/'" :content="content">
                       <form :enctype="enctype"   :method="method"  :action="action" class="js-form">
                         <core-ajax :src="action" :method="method"   :isfile="!0" :contentType="enctype" :data="formData" :header="headers" :auto="!1" @on:success="onFormSuccess"    @on:startfileupload="onFormFilesubmit"     @on:error="onFormError" inline-template>
                           <div></div>
                         </core-ajax >
                            <div class="u-relative u-vacuum">

                              <core-input  :isRequired="!0" :Typess="'file'" :isfile="!0"   :processIn="processIni"  :content="content" @on:success="onInputSuccess(0)" @on:error="onInputError(0)"  @on:mounted="onInputMounted" inline-template>
                                <div style="border: 1px solid #000000;" class="c-footer__input u-relative u-inline-block u-valign-top u-marg-r-sm u-w2of10 u-w9of10@sm u-w6of8@xs u-marg-r-0@xs u-marg-b-xl@sm u-align-left ">
                                  <span class="c-footer__carrer__msgTitle  u-absolute t-text--sm u-color--gray" id="jobanswer1" ></span>  
                                  <span class="c-footer__carrer__msgTitle  u-absolute t-text--sm u-color--gray" id="jobanswer1" ></span><span class="c-footer__carrer__msgTitle___answer   u-absolute t-text--xs u-color--gray" id="jobanswer" ></span>
                                  <span class="c-footer__carrer__msgCompany u-absolute t-text--sm u-color--gray" id="companswer1"></span><span class="c-footer__carrer__msgCompany___answer   u-absolute t-text--xs u-color--gray" id="companswer"></span>
                                  <span class="c-footer__carrer__upload__Careers u-absolute t-text--sm u-color--gray" id="Custom_text__upload__Careers" v-html="content.Carrer_placeholder"></span>
                                   <input type="hidden"  name="Jobtitle" id="jobanswerIn"  />
                                   <input type="hidden"  name="Company" id="companswerIn"  />
                                   <input type="file" autocomplete="off" @change="handleFileUpload()" id="fileCV"  name="fileCV" :placeholder="content.Carrer_placeholder" class="t-input t-text--sm u-relative u-pad-l-md u-fit-w u-fit-h u--color-input"  @blur="onFocusOut"   />
                                    <span class="c-footer__input__msg c-footer__input__msg--error-format u-absolute t-text--xs u-color--black" v-html="content.Carrer_error_not_valid"></span>
                                    <span class="c-footer__input__msg c-footer__input__msg--success u-absolute t-text--xs u-color--black" v-html="content.Carrer_success_saved"></span>
                                    <span class="c-footer__input__msg c-footer__input__msg--error u-absolute t-text--xs u-color--black" v-html="content.Carrer_error_wrong"></span>
                                    <vue-simple-spinner line-fg-color="#231f20" spacing="1" v-show="processIn"   size="32" :message="content.Carrer_supload_text" />
                                  </div>
                                </core-input>
                                <core-input  :isRequired="!0" :Typess="'text'" :isfile="!1"   :content="content" @on:success="onInputSuccess(1)" @on:error="onInputError(1)"  @on:mounted="onInputMounted" inline-template>
                                  <div class="c-footer__input u-relative u-inline-block u-valign-top u-marg-r-sm u-w2of10 u-w9of10@sm u-w6of8@xs u-marg-r-0@xs u-marg-b-xl@sm" style="border: 1px solid rgb(0, 0, 0);">
                                     <span class="c-footer__carrer__upload__Careers u-absolute t-text--sm u-color--gray" id="Custom_text__name" v-html="content.Carrer_name_apply"></span>
                                    <input type="text" autocomplete="off" name="name"  class="t-input t-text--sm u-relative u-pad-l-md u-fit-w u-fit-h u--color-input" @focus="onFocusInName"  @blur="onFocusOut"   />
                                    <span class="c-footer__input__msg c-footer__input__msg--error-format u-absolute t-text--xs u-color--black" v-html="content.Carrer_name_error_not_valid"></span>
                                  </div>
                                </core-input>
                                <core-input  :isRequired="!0" :Typess="'email'" :isfile="!1"   :content="content" @on:success="onInputSuccess(2)" @on:error="onInputError(2)"  @on:mounted="onInputMounted" inline-template>
                                  <div class="c-footer__input u-relative u-inline-block u-valign-top u-marg-r-sm u-w2of10 u-w9of10@sm u-w6of8@xs u-marg-r-0@xs u-marg-b-xl@sm" style="border: 1px solid rgb(0, 0, 0);">
                                     <span class="c-footer__carrer__upload__Careers u-absolute t-text--sm u-color--gray" id="Custom_text__email" v-html="content.newsletter_placeholder"></span>
                                    <input type="text" autocomplete="off" name="mail"  class="t-input t-text--sm u-relative u-pad-l-md u-fit-w u-fit-h u--color-input" @focus="onFocusIn"  @blur="onFocusOut"   />
                                    <span class="c-footer__input__msg c-footer__input__msg--error-format u-absolute t-text--xs u-color--black" v-html="content.newsletter_error_not_valid"></span>
                                  </div>
                                </core-input>
                                
                                    <button class="c-footer__btn-submit t-btn t-btn--primary t-text--sm u-marg-r-sm u-marg-l-sm u-relative u-bg--brand-Botton-color u-color--white u-pad-x-md" @click="onFormSubmit" v-html="content.Carrer_button_label">
                                       <div class="t-btn--primary__bg o-wrapper--panel u-fit"></div>
                                       <span class="u-relative u-inline-block u-valign-middle u-marg-r-sm" v-html="content.newsletter_button_label"></span>
                                       <img src="../../assets/medias/images/icons/arrow-right-white.svg" class="t-icon--arrow-right u-relative u-inline-block u-valign-middle"/>
                                    </button>
                                </div>
                              </form>
                 </core-ajax-form>
        </div>
</section>
<div class="u-relative u-pad-y-xl u-pad-x-w1of12">
      <router-link  to="/" class="c-footer__logo t-link u-inline-block u-marg-b-lg">
        <img src="../../assets/medias/images/RG-wordmark-reverse-bigger.svg" class="c-loader-intro__logo__ribbon__AV" style="margin-left:-50px;">
      </router-link>
      <div class="u-relative u-marg-b-md">
        <a href="javascript:void(0);"  @click="scrollToTop"  class="c-footer__link c-footer__scrolltop t-link t-text--xxs t-text-ls--md u-absolute u-relative@sm u-pos-bl u-color--white u-uppercase">
          <span class="u-inline-block u-valign-middle">Top</span>
           <img src="../../assets/medias/images/icons/arrow-top-gray.svg" class="c-footer__scrolltop__icon t-icon--arrow-top-white u-inline-block u-valign-bottom">
         </a>
          <ul class="o-list--inline u-marg-t-md@sm u-block u-valign-bottom">
              <li class="o-list__item u-marg-r-mds u-fit-w@sm u-marg-r-0@sm u-marg-b-xs@sm"  v-for="(item, index)  in globalContent.nav.links">
                <router-link  :to="item.href" class="c-footer__link t-link t-text-ls--md  u-color--white"  active-class="is-active" exact>{{item.label}}</router-link>
              </li>
          </ul>
      </div>
      <div class="c-line c-line--x u-bg--white u-marg-b-md"></div>
      <div class="u-relative u-align-left u-align-center@sm">
          <div class="u-absolute u-relative@sm u-pos-tr">
              <router-link  to="/terms-and-conditions" class="t-link t-text--sm u-inline-block u-color--gray-white u-relative@sm u-marg-b-xs@sm"  active-class="is-active" exact></router-link>
            </div>
          <p class="u-marg-t-md@sm t-text--sm u-color--white">{{copyright}}</p>
      </div>
  </div>
  </footer>
</template>
<script>
import      AppScrollObject from     '../app-scroll-object/index.vue'
import      CoreAjaxForm from     '../core-ajax-form/index.vue'
import  AppSlicedText from '../app-sliced-text/index.vue'
import {getAbsoluteBoundingRect}  from '../../utilities/getAbsoluteBoundingRect.js'
var firstScrollTo = require('vue-scrollto');
//const firstScrollTo = scroller()

export default {
  props: {
                    debug: {
                        type: Boolean,
                        default: !1
                    },
                    adminContent: {
                        type: Object,
                        default: function() {}
                    },
                    globalContent: {
                        type: Object,
                        default: function() {}
                    },
                    newsletterShown: {
                        type: Boolean,
                        default: !1
                    }
                    ,
                    careersShown: {
                        type: Boolean,
                        default: !1
                    }
                },
                components: {
                    'app-scroll-object':AppScrollObject,
                    'core-ajax-form':CoreAjaxForm,
                    "app-sliced-text":AppSlicedText

                },
                computed: {
                    content: function() {
                        return this.adminContent.en["theme-general-settings"]
                    },
                    copyright: function() {
                        return this.content.footer_copyright_label.replace("<year>", (new Date).getFullYear())
                    }
                },
                mounted: function()
                {
                      this.eventHub.$on("footer:applyto", this.onApplyTo)
                },
                destroyed: function()
                {
                    this.eventHub.$off("footer:applyto", this.onApplyTo)
                },
                methods: {
                    scrollToTop: function() {
                        window.scrollTo(0, 0)
                    },
                    onApplyTo:function(t,p)
                    {
                        this.$el.querySelector("#jobanswer1").innerHTML="Job Title:",
                        this.$el.querySelector("#companswer1").innerHTML="Company:",
                        this.$el.querySelector("#jobanswerIn").value=t,
                        this.$el.querySelector("#companswerIn").value=p,
                        this.$el.querySelector("#jobanswer").innerHTML=t,
                        this.$el.querySelector("#companswer").innerHTML=p,
                        firstScrollTo.scrollTo("#careersection")
                      }
                }
}
</script>
<style  scoped>
</style>



// WEBPACK FOOTER //
// src/components/app-footer/index.vue